// generated from 32_823 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const pushSubscriptionStatusFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("push_subscription_status_filter"),
  comparison_key: z.enum([
    "1", // 25_077 (76.40%)
    "2", // 7_746 (23.60%)
  ]),
  display_name: z.string(),
  // undefined: 8_675 (26.43%), defined 24_148 (73.57%)
  raw_value: common
    .numericEnum([
      2, // 12_662 (52.43%)
      0, // 6_231 (25.80%)
      1, // 5_255 (21.76%)
    ])
    .optional(),
  value: common.numericEnum([
    2, // 17_654 (53.79%)
    0, // 8_433 (25.69%)
    1, // 6_736 (20.52%)
  ]),
  varies_by_app_group: z.literal(false),
});
